module.exports = new __parcel__URL__("audio-formats.91100584.png").toString();